import React, { useState, useEffect } from "react";
import { Checkbox, FormControlLabel } from "@mui/material";
import api from "../../api/api";
import ToastMessage from "../../utils/mui/righttoptoast";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";

const AddNotesPopup = ({ isOpen, dt,fetchsuggestions, userdata, onClose }) => {
  const [inputtext, setInputText] = useState('');

  const [openToast, setOpenToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastSeverity, setToastSeverity] = useState('success');
  const practiseid = window.getPracticeId();
  const [isSubmitting, setIsSubmitting] = useState(false);
 const userConfig = useSelector((state) => state.userconfig);
  // Track checked status
  const [checked, setChecked] = useState({
    PROVIDER: false,
    "FRONT/BACK OFFICE": false,
    MA: false,
    LAB: false,
    BILLING: false,
    all: false,
  });

  // Track manual selection to avoid auto-deselecting user choices
  const [manualSelection, setManualSelection] = useState({});

  const handleToastClose = () => setOpenToast(false);
  const handleChange = (e) => setInputText(e.target.value);

  const handleCheckboxChange = (event, name) => {
    setChecked((prev) => {
      const updated = { ...prev, [name]: event.target.checked };

      // Track manual selection
      setManualSelection((prevManual) => ({ ...prevManual, [name]: true }));

      // Update "all" if all others are selected
      const allTrue = Object.keys(updated)
        .filter((key) => key !== "all")
        .every((key) => updated[key]);
      updated.all = allTrue;

      return updated;
    });
  };

  const handleSelectAllChange = () => {
    const newCheckedState = !checked.all;
    setChecked({
      PROVIDER: newCheckedState,
      "FRONT/BACK OFFICE": newCheckedState,
      MA: newCheckedState,
      LAB: newCheckedState,
      BILLING: newCheckedState,
      all: newCheckedState,
    });

    // Mark all as manually selected
    setManualSelection({
      PROVIDER: true,
      "FRONT/BACK OFFICE": true,
      MA: true,
      LAB: true,
      BILLING: true,
    });
  };

  // Auto-select/deselect BILLING based on input text
  useEffect(() => {
    const containsBilling = /bill/i.test(inputtext);
    if (!manualSelection.BILLING) {
      setChecked((prev) => {
        if (containsBilling && !prev.BILLING) {
          return { ...prev, BILLING: true };
        } else if (!containsBilling && prev.BILLING) {
          return { ...prev, BILLING: false };
        }
        return prev;
      });
    }
  }, [inputtext, manualSelection]);

  const handleSubmit = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);
const userRole = `- ${Object.keys(checked)
  .filter((key) => checked[key] && key !== "all")
  .join(" - ")}`;


    try {
      const createResponse = await api.post(`/v1/${practiseid}/patient/${userdata.patientid}/orders/create`, {
        department_id: 1,
        patient_name: `${userdata.firstname || ''} ${userdata.lastname || ''}`.trim(),
        tov: "FOLLOW UP",
        lov: userdata.lov,
        diagnosis: "",
        ordertype: "Notes",
        ordername: inputtext,
        schedule: "f",
        // provider:userConfig?.username,
        provider: `${userConfig?.firstname || ""} ${userConfig?.lastname || ""}`,
        user_role: userRole,
        status: "CREATED",
        confirm_status: "C",
        orderdate: dt && dt.includes(' ') && !isNaN(Date.parse(dt.split(' ')[0]))
          ? dt.split(' ')[0]
          : new Date().toISOString().split('T')[0],
        encounterid: 0,
      });

      if (createResponse.status === 200) {
        setToastMessage('Notes added successfully!');
        setToastSeverity('success');
        setOpenToast(true);
        setInputText('');
        setChecked({
          PROVIDER: false,
          "FRONT/BACK OFFICE": false,
          MA: false,
          LAB: false,
          BILLING: false,
          all: false,
        });
        setManualSelection({});
        fetchsuggestions();
        setTimeout(() => {
          setOpenToast(false);
          setIsSubmitting(false);
          onClose();
        }, 2000);
      } else {
        throw new Error('Failed to add notes');
      }
    } catch (error) {
      setToastMessage('Failed to add notes. Please try again.');
      setToastSeverity('error');
      setOpenToast(true);
      setIsSubmitting(false);
    }
  };

  return (
    isOpen && (
      <>
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="relative flex flex-col gap-2 w-[386px] bg-white px-4 pb-6 rounded-lg shadow-lg text-left">
            <div className="w-full flex items-center justify-between mt-2">
              <span className="ml-2 font-semibold text-[#1D2951] text-base text-center">
                ADD NOTES
              </span>
              <button
                className="text-gray-500 hover:text-gray-700 text-[30px]"
                onClick={() => {
                  if (!isSubmitting) {
                    setInputText('');
                    setChecked({
                      PROVIDER: false,
                      "FRONT/BACK OFFICE": false,
                      MA: false,
                      LAB: false,
                      BILLING: false,
                      all: false,
                    });
                    setManualSelection({});
                    onClose();
                  }
                }}
                disabled={isSubmitting}
              >
                &times;
              </button>
            </div>
            <div className="h-px bg-[#D0D5DD]"></div>

            {/* Select All Button */}
            <div>
              <button
                onClick={handleSelectAllChange}
                className={`rounded-full py-2 px-4 transition text-sm duration-300 ease-in-out shadow-[0px_4px_4px_#00000040] ${
                  checked.all ? "bg-[#E17954] text-white" : "bg-[#F3F3F3] text-[#686868]"
                }`}
                disabled={isSubmitting}
              >
                Select All
              </button>
            </div>

            {/* Individual Checkboxes */}
            {[
              { name: "PROVIDER", label: "PROVIDER" },
              { name: "MA", label: "MA" },
              { name: "FRONT/BACK OFFICE", label: "FRONT/BACK OFFICE" },
              { name: "LAB", label: "LAB" },
              { name: "BILLING", label: "BILLING" },
            ].map((item) => (
              <div className="w-full flex justify-between items-center h-[40px]" key={item.name}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={checked[item.name]}
                      onChange={(e) => handleCheckboxChange(e, item.name)}
                      color="primary"
                      disabled={isSubmitting}
                    />
                  }
                  label={item.label}
                  sx={{
                    '.MuiFormControlLabel-label': {
                      fontSize: '14px',
                      color: "#4B4B4B",
                      fontFamily: "sans-serif",
                    },
                  }}
                />
              </div>
            ))}

            {/* Message Input */}
            <div className="flex flex-col space-y-2 w-full">
              <label className="text-[#232323]">Enter message here</label>
              <textarea
                value={inputtext}
                onChange={handleChange}
                className="w-full h-32 p-3 border border-gray-300 rounded-md resize-none"
                placeholder="Type your note here..."
                disabled={isSubmitting}
              />
            </div>

            {/* Submit Button */}
            <div className="w-full flex justify-center mt-2">
              <button
                onClick={handleSubmit}
                className={`rounded-full py-1 px-6 transition text-[14px] duration-300 ease-in-out shadow-[0px_4px_4px_#00000040] ${
                  isSubmitting || inputtext.trim() === ''
                    ? 'bg-gray-300 text-gray-600 cursor-not-allowed'
                    : 'bg-[#50869A] text-[#FFFFFF]'
                }`}
                disabled={isSubmitting || inputtext.trim() === ''}
              >
                ADD NOTES
              </button>
            </div>
          </div>
        </div>

        <ToastMessage
          message={toastMessage}
          severity={toastSeverity}
          open={openToast}
          handleClose={handleToastClose}
        />
      </>
    )
  );
};

export default AddNotesPopup;
